import { Import } from "@/apps/dashboard/catalog/core/domain/Import";
import { ImportResponse } from "@/apps/dashboard/catalog/core/infrastructure/repository/importRepository";
import { ImportReport } from "@/apps/dashboard/catalog/core/domain/ImportReport";
import { ImportLinesCount } from "@/apps/dashboard/catalog/core/domain/ImportLinesCount";
import NamedId from "@/apps/dashboard/catalog/core/domain/NamedId";

export class ImportMapper {
  static toModel(data: ImportResponse): Import {
    const linesCount = new ImportLinesCount(
      data.report?.lines_count.found ?? null,
      data.report?.lines_count.inserted ?? null,
      data.report?.lines_count.updated ?? null,
      data.report?.lines_count.ignored ?? null
    );
    return new Import(
      data.id,
      data.origin,
      data.created_at,
      data.destination_account ? new NamedId(data.destination_account.id, data.destination_account.common_name) : null,
      data.source_account ? new NamedId(data.source_account.id, data.source_account.common_name) : null,
      data.created_by ? new NamedId(data.created_by.id, data.created_by.name) : null,
      data.status,
      data.content,
      data.strategy,
      data.queued_at,
      data.started_at,
      data.ended_at,
      new ImportReport(data.report?.error ?? null, linesCount, data.report?.ignored_lines ?? [])
    );
  }
}
